import axios from 'axios';

const VISITS_API_BASE = 'https://dev.hedgeiot.epu.ntua.gr/api';

export const getVisitsForHouse = (houseId) => {
    return new Promise((resolve, reject) => {
        if (!houseId) {
            resolve([]);
            return;
        }
        axios
            .get(`${VISITS_API_BASE}/visit/getallforhouse/${houseId}`)
            .then((response) => {
                resolve(response.data);
            })
            .catch(reject);
    });
};

export const createVisit = (payload) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${VISITS_API_BASE}/visit/create`, payload)
            .then((response) => {
                resolve(response.data);
            })
            .catch(reject);
    });
};

export const updateVisit = (visitId, payload) => {
    return new Promise((resolve, reject) => {
        if (!visitId) {
            reject(new Error('visitId is required'));
            return;
        }
        axios
            .patch(`${VISITS_API_BASE}/visit/update/${visitId}`, payload)
            .then((response) => {
                resolve(response.data);
            })
            .catch(reject);
    });
};

export const deleteVisit = (visitId) => {
    return new Promise((resolve, reject) => {
        if (!visitId) {
            reject(new Error('visitId is required'));
            return;
        }
        axios
            .delete(`${VISITS_API_BASE}/visit/delete/${visitId}`)
            .then((response) => {
                resolve(response.data);
            })
            .catch(reject);
    });
};
